"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Include = exports.Parameter = exports.Optional = exports.Schema = exports.ClassSchema = exports.Operation = exports.metadata = void 0;
exports.metadata = {
    operation: new Map(),
    className: new Map(),
    classSchema: new Map(),
    schema: new Map(),
    optional: new Map(),
    parameter: new Map(),
    include: new Map(),
};
function Operation(operation) {
    return (prototype, propertyKey) => {
        setPropertyMetadata('Operation', prototype, propertyKey, exports.metadata.operation, operation);
    };
}
exports.Operation = Operation;
function ClassSchema(data) {
    return (theClass) => {
        if (exports.metadata.classSchema.has(theClass)) {
            throw new Error(`@ClassSchema already called for class ${theClass.name}`);
        }
        const { name, ...classSchema } = data;
        if (name) {
            exports.metadata.className.set(theClass, name);
        }
        exports.metadata.classSchema.set(theClass, classSchema);
    };
}
exports.ClassSchema = ClassSchema;
function Schema(data = {}) {
    return (prototype, propertyKey) => {
        setPropertyMetadata('Schema', prototype, propertyKey, exports.metadata.schema, data);
    };
}
exports.Schema = Schema;
function Optional() {
    return (prototype, propertyKey) => {
        assertPropertyIsString(propertyKey);
        const optionals = exports.metadata.optional.get(prototype) || new Set();
        optionals.add(propertyKey);
        exports.metadata.optional.set(prototype, optionals);
    };
}
exports.Optional = Optional;
function Parameter(data) {
    return (prototype, propertyKey) => {
        setPropertyMetadata('Parameter', prototype, propertyKey, exports.metadata.parameter, data);
    };
}
exports.Parameter = Parameter;
function Include(...otherClasses) {
    return (theClass) => {
        const includes = exports.metadata.include.get(theClass) || new Set();
        for (const otherClass of otherClasses) {
            includes.add(otherClass);
        }
        exports.metadata.include.set(theClass, includes);
    };
}
exports.Include = Include;
function assertPropertyIsString(propertyKey) {
    if (typeof propertyKey !== 'string') {
        throw new TypeError('Property key must be a string');
    }
}
function setPropertyMetadata(decorator, prototype, propertyKey, metadataMap, data) {
    assertPropertyIsString(propertyKey);
    const byProperty = metadataMap.get(prototype) || new Map();
    if (byProperty.has(propertyKey)) {
        throw new Error(`@${decorator} already called for ${prototype.constructor.name}.${propertyKey}`);
    }
    byProperty.set(propertyKey, data);
    metadataMap.set(prototype, byProperty);
}
